import React from 'react';
export function FAQ() {
  const faqs = [{
    q: 'How long until I see results?',
    a: 'Most clients see improved lead quality within 30 days.'
  }, {
    q: 'Do I need to spend money on ads?',
    a: 'You can start by improving the conversion of your existing ads and website traffic, and we can layer in ads to scale once the system is performing.'
  }, {
    q: "What if it doesn't work?",
    a: 'Month-to-month pricing means you can cancel anytime.'
  }];
  return <section className="py-24 bg-slate-50" data-id="element-86">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-87">
        <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-12 text-center" data-id="element-88">
          Frequently Asked Questions
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-89">
          {faqs.map((faq, index) => <div key={index} className="bg-white p-6 rounded-xl shadow-sm border border-slate-100" data-id="element-90">
              <h3 className="font-bold text-lg text-slate-900 mb-3" data-id="element-91">{faq.q}</h3>
              <p className="text-slate-600" data-id="element-92">{faq.a}</p>
            </div>)}
        </div>
      </div>
    </section>;
}